import { injectable } from "inversify";
import type { Subscription } from "rxjs";

@injectable()
export abstract class BaseViewModel {
    private compositeSubscriptions: Subscription[] = [];

    addSub(...subscriptions: Subscription[]): void {
        this.compositeSubscriptions =
            this.compositeSubscriptions.concat(subscriptions);
    }

    didMount?(): Promise<void> | void;

    willUnmount(): void {
        this.compositeSubscriptions.forEach((subscription) => {
            subscription.unsubscribe();
        });
        this.compositeSubscriptions = [];
    }
}
